import api from "./index"

export const getUsers = () =>
  api.get("/admin/users")

export const approveUser = (id) =>
  api.patch(`/admin/users/${id}/approve`)

export const rejectUser = (id) =>
  api.patch(`/admin/users/${id}/reject`)

export const changeUserRole = (id, role) =>
  api.patch(`/admin/users/${id}/role`, { role })
